import { CERelationshipAttributePermissionAttributesBase } from './ce-relationship-attribute-permission-attributes-base'


export class CERelationshipAttributePermissionAttributes extends CERelationshipAttributePermissionAttributesBase {

}